import { transactionsApi } from './api';

export type ValueExistsParams = {
  column: string;
  value: string;
  /** Defaults to VES (typical uniqueness scope for this validation). */
  currency?: string;
  /** Kept for API compatibility; value-exists always uses HTTP until core-v1 implements VALUE_EXISTS. */
  hashedId?: string | null;
  /**
   * @deprecated core-v1 socket-service does not handle VALUE_EXISTS yet.
   * Sending it as payment_page_event `action` fails ValidationPipe (Internal server error)
   * and can break the confirm/start-transaction flow. Always uses HTTP.
   */
  preferSocket?: boolean;
};

/**
 * Database value-exists check via forms constructor HTTP
 * `GET /transactions/value-exists` (server-side DB lookup).
 *
 * Not sent over the payment socket: PaymentPageReqType only supports
 * TRACK_ACTION / START_TRANSACTION today.
 */
export async function checkValueExists(params: ValueExistsParams): Promise<{ exists: boolean }> {
  const { column, value, currency = 'VES' } = params;
  return transactionsApi.valueExists(column, value, currency);
}
